// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__1Kqwp","choiceBoxes":"toolbarselects_choiceBoxes__2zzWx","simpleField":"toolbarselects_simpleField__1Py1b"};